import React, { useEffect, useMemo } from 'react'
import {
  selectPackerStats,
  selectPackerStatsLoading
} from 'modules/flightControl/ducks/selectors'
import { fetchFlightControlStatsByRoleRoutine } from 'modules/flightControl/ducks/actions'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Table from 'components/Table'
import { isNotNilOrEmpty } from 'utils/ramda'
import { keys } from 'ramda'
import CircleIcon from '@mui/icons-material/Circle'

const PackerStatsTable = () => {
  const stats = useSelector(selectPackerStats)
  const isLoading = useSelector(selectPackerStatsLoading)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchFlightControlStatsByRoleRoutine({ role: 'packer' }))
  }, [])

  const users = useMemo(() => {
    if (isNotNilOrEmpty(stats)) {
      const logins = keys(stats)
      return logins.map(login => stats[login])
    } else {
      return []
    }
  }, [stats])

  const headers = [
    { children: 'Login' },
    { children: 'Czas logowania' },
    { children: '1 SKU (szt/h)' },
    { children: 'Multi SKU (szt/h)' },
    { children: 'Aktywny' }
  ]

  const rows = users.map(user => ({
    cells: [
      { children: user.login },
      { children: user.loginTime },
      { children: user.singleSkuPerH },
      { children: user.multiSkuPerH },
      {
        children: (
          <BulletWrapper>
            <BulletIcon active={user.isActive} />
          </BulletWrapper>
        )
      }
    ]
  }))

  return (
    <Wrapper>
      <Header>Statystyki Pakowacza</Header>
      <Table rows={rows} headers={headers} isLoading={isLoading} />
    </Wrapper>
  )
}

export default PackerStatsTable

const Wrapper = styled.div`
  max-width: 450px;
  min-width: 450px;
  padding: 10px;
  border-radius: 8px;
  background-color: #f0f3f4;
`

const Header = styled.div`
  margin-bottom: 15px;
  font-weight: bold;
  font-size: 18px;
`

const BulletWrapper = styled.div`
  text-align: center;
`

const BulletIcon = styled(CircleIcon)`
  font-size: 12px !important;
  color: ${({ theme, active }) =>
    active ? theme.colors.success : theme.colors.error};
`
